export default __webpack_public_path__ + "static/media/service1.4bc7992c.jpg";